export const LANGUAGE = {
    ENGLISH: 'GB',
    UKRAINIAN: 'UA',
    PORTUGUESE: 'PT',
    SPANISH: 'ES',
    PORTUGUESE_BRAZIL: 'BR',
    SPANISH_MEXICO: 'MX',
};

export const Languages = [LANGUAGE.ENGLISH, LANGUAGE.UKRAINIAN, LANGUAGE.PORTUGUESE, LANGUAGE.SPANISH];

export const CATEGORY_DISPLAY_NAME_PROP = {
    [LANGUAGE.ENGLISH]: 'displayNameEn',
    [LANGUAGE.SPANISH]: 'displayNameEs',
    [LANGUAGE.PORTUGUESE]: 'displayNamePt',
    [LANGUAGE.UKRAINIAN]: 'displayNameUk',
    [LANGUAGE.PORTUGUESE_BRAZIL]: 'displayNameBr',
    [LANGUAGE.SPANISH_MEXICO]: 'displayNameEs',
};

export const SURVEY_LANGUAGE = {
    GB: 'GB',
    ES: 'ES',
    DE: 'DE',
    FR: 'FR',
    UA: 'UA',
    PT: 'PT',
    BR: 'BR',
    RU: 'RU',
    PL: 'PL',
};
